import { withInstall } from "@xplus/utils/with-install";
import tag from "./src/tag.vue";
export const xTag = withInstall(tag);
export default xTag;
export * from "./src/tag";
